var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Wedding Events")]),_c('tabs',{attrs:{"tabs":['Timeline', 'Map']},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var selectedTab = ref.selectedTab;
return [(selectedTab === 'Timeline')?_c('timeline',{attrs:{"timeline":_vm.timeline}}):(selectedTab === 'Map')?_c('events-map',{staticClass:"events-map",attrs:{"events":_vm.events}}):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }